
const Loading = () => {
  return (
    <div className='d-flex justify-content-center align-items-center' style={{height:'100vh'}}>
       {/*  <Lottie animationData={animationData} style={{width:200,height:200}}/>   */}
       <p>Loading...</p>
    </div>
     
  )
}

export default Loading